import React from 'react';
import PropTypes from 'prop-types';
import SectionTitle from '../../shared/SectionTitle';
import RichEditor from '../../shared/RichEditor';
import styles from './styles.scss';
import messages from '../../../constants/messages';
import SectionDescription from '../../shared/SectionDescription';

const SuggestedGuidelines = ({ value, onChange, error }) => {
  return (
    <div>
      <SectionTitle title="Suggested Guidelines for Re-Testing *" key="suggestedGuidelinesTitle" />
      <RichEditor
        key="retestingGuidelines"
        initValue={value}
        onChange={(value) => onChange('retestingGuidelines', value)}
      />
      {error && <label className={styles.error}>{messages.validation.blankField}</label>}
      <SectionDescription
        className="mt-2"
        description="Only images uploaded from your local drive can be displayed in reports"
      />
    </div>
  );
};

SuggestedGuidelines.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  error: PropTypes.bool,
};

export default SuggestedGuidelines;



// WEBPACK FOOTER //
// src/components/reportContentLayout/SuggestedGuidelines/index.jsx